import { inject, Pipe, PipeTransform } from '@angular/core';
import { DROPDOWN_TRANSFORMERS } from '../app.constants';

@Pipe({ name: 'libIKPDropdownOptionPipe', standalone: true })
export class DropdownOptionPipe<TKey extends PropertyKey, TReturnTypeMap extends Record<TKey, TReturnTypeMap[keyof TReturnTypeMap]>, TInput>
  implements PipeTransform
{
  private readonly transformers = inject<{ [K in TKey]: (value: TInput) => TReturnTypeMap[K][] }>(DROPDOWN_TRANSFORMERS);

  transform<K extends TKey>(input: TInput, transformerKey: K): TReturnTypeMap[K][] {
    return this.transformers[transformerKey](input);
  }
}
